import { useEffect } from "react";

/* Cerrar con Esc.
 *
 * Un panel que tapa media pantalla y sólo se cierra con un botón obliga a ir a
 * buscar el botón con el mouse cada vez, y en una pantalla de carga se abre y
 * se cierra veinte veces seguidas.
 *
 * Se escucha en `keydown` del documento y no en el propio panel: el foco puede
 * estar en cualquier casilla de adentro, o en ninguna si se abrió con el mouse
 * y todavía no se tocó nada.
 *
 * NO cierra con clic afuera. Acá adentro se está tipeando, y un clic perdido
 * que borra media carga es peor que un botón de más. Esc es una tecla que hay
 * que elegir apretar.
 */
export function useCerrarConEsc(onClose, activo = true) {
  useEffect(() => {
    if (!activo || typeof onClose !== "function") return undefined;
    const alTeclear = (e) => {
      if (e.key === "Escape") {
        e.stopPropagation();
        onClose();
      }
    };
    document.addEventListener("keydown", alTeclear);
    return () => document.removeEventListener("keydown", alTeclear);
  }, [onClose, activo]);
}

export default useCerrarConEsc;
